const getRequiredEnvVar = (value, name) => {
  if (typeof value === 'undefined') throw new Error(`Required Environment Variable not set: ${name}`);
  return value;
};

export default getRequiredEnvVar;
